<template>
  <default-layout>
    <div class="pa-4">
      <register formType="page" />
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Register from '@/components/auth/register';
import { mapState } from 'vuex';

import DefaultHeadMixin from '@/mixins/defaultHead';

export default {
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    Register,
  },
  computed: {
    ...mapState({}),
  },
  methods: {},
  mounted() {},
};
</script>
